import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss, Box } from '@atlaskit/primitives';

const SpaceSettingsPageContainerStyles = xcss({
	backgroundColor: 'elevation.surface',
	height: '100%',
	paddingBlock: 'space.600',
	paddingInline: 'space.800',
});

export const SpaceSettingsPageContainer = ({
	children,
	testId,
}: {
	children: React.ReactNode;
	testId?: string;
}): React.JSX.Element => (
	<Box xcss={SpaceSettingsPageContainerStyles} testId={testId}>
		{children}
	</Box>
);
